import { StyleSheet } from 'aphrodite';
import { THEME } from '../Theme/theme';

export const styleSheet = StyleSheet.create({
	// Preview styles
	preview: {
		backgroundColor: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: 12,
		padding: THEME.spacing.lg,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	previewContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	previewName: {
		fontSize: 24,
		fontWeight: 600,
		color: THEME.colors.text.main,
		lineHeight: 1.2,
	},
	previewSource: {
		fontSize: 12,
		color: THEME.colors.text.light,
		textTransform: 'uppercase',
		letterSpacing: '0.5px',
	},
	previewSample: {
		fontSize: 14,
		color: THEME.colors.text.light,
		marginTop: THEME.spacing.sm,
		paddingTop: THEME.spacing.md,
		borderTop: `1px solid ${THEME.colors.border.light}`,
		lineHeight: 1.5,
	},
	previewActions: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.md,
		marginTop: THEME.spacing.xs,
	},

	// Editor styles
	editor: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	field: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	label: {
		fontSize: 14,
		fontWeight: 500,
		color: THEME.colors.text.main,
	},
	trigger: {
		backgroundColor: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		color: THEME.colors.text.main,
		height: 44,
		width: '100%',
		minWidth: '100%',
	},
	dropdownContent: {
		minWidth: 200,
	},
	fontList: {
		maxHeight: 300,
		overflowY: 'auto',
	},
	customUrlOption: {
		borderTop: `1px solid ${THEME.colors.border.light}`,
		marginTop: THEME.spacing.xs,
		paddingTop: THEME.spacing.sm,
		fontStyle: 'italic',
	},
	customUrlField: {
		marginTop: THEME.spacing.md,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	input: {
		backgroundColor: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		fontSize: 14,
		color: THEME.colors.text.main,
		width: '100%',
		':focus': {
			outline: 'none',
			borderColor: THEME.colors.primary.main,
		},
	},
	doneButton: {
		marginTop: THEME.spacing.sm,
		alignSelf: 'flex-start',
	},
	editActions: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: THEME.spacing.sm,
	},
});
